import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { Link } from '@material-ui/core';
import { vaultPasswordsService } from '@app/services';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';

const DownloadMigratorComponent = () => {
    const { translation } = useTypedTranslation();

    const [migratorZipUrl, setMigratorZipUrl] = useState('');
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    useEffect(() => {
        vaultPasswordsService.getMigratorUrl(handleError, handleSuccessMigratorUrl);
    }, []);

    const handleSuccessMigratorUrl = (response: any) => {
        setMigratorZipUrl(response.data.Url);
    };

    const handleError = (errorResponse: any) => {
        if (errorResponse.data.error) {
            setErrorMessage(errorResponse.data.error.message);
        }
        else if (errorResponse.message) {
            setErrorMessage(errorResponse.message);
        }
        else {
            setErrorMessage(translation('GENERIC_ERROR'));
        }
    };

    return (
        <>
            <Link href={migratorZipUrl}>
                {translation('ON_PREM_MIGRATOR_DOWNLOAD_TOOL')}
                <SystemUpdateAltIcon />
            </Link>

            {
                errorMessage &&
                <div className='modal__error'>{errorMessage}</div>
            }
        </>
    );
};

export default DownloadMigratorComponent;